import mitt from 'mitt';

// Create an event bus instance
const emitter = mitt();

export default emitter;